// Colors matching the dark theme (shared between canvas and SVG renderers)
export const COLORS = {
  background: '#161616',
  surface: '#161616',
  gridLine: 'rgba(255,255,255,0.05)',
  axisLine: '#2b2b2b',
  text: '#c7c2b8', // Text Muted — axis + tick labels
  textLight: '#c3c1bb',
  // Was #2196F3 (stock Material blue) — a second, off-brand blue beside the
  // Up/Call token. Now the brand value.
  callGex: '#1c76a2',
  putGex: '#d8483b',
  // Minor walls. A lighter tint of the same hue rather than the major at
  // reduced opacity: opacity made them read as "faint", which is a statement
  // about confidence in the level, not about its size. These are solid — same
  // kind of level, smaller one.
  callGexMinor: '#4a93bd',
  putGexMinor: '#a8362b',
  currentPrice: '#c2a14e',
  pillInk: '#1c1606', // Hot Tag Text — sits on any solid brand fill
  candleUp: '#f4f2ed', // Candle Up — monochrome bone
  candleDown: '#61615e', // Candle Down — monochrome gray
  watermark: 'rgba(255, 255, 255, 0.08)',
} as const;

// Chart layout margins (in CSS pixels)
export const MARGINS = {
  top: 8,
  right: 0, // Y-axis is on the GEX panel side
  bottom: 30, // space for X-axis labels
  left: 4,
} as const;

// GEX profile panel layout
export const GEX_MARGINS = {
  top: 8,
  right: 50, // space for Y-axis labels
  bottom: 30,
  left: 4,
} as const;

// Narrow Y-axis when GEX panel is small (sidebar mode)
export const GEX_MARGINS_NARROW = {
  top: 8,
  right: 36,
  bottom: 30,
  left: 4,
} as const;

export const WATERMARK_PATH = '/logo-watermark.png';
export const WATERMARK_OPACITY = 0.10;
// Watermark is sized as a FRACTION of the chart box so it matches the
// Plotly tools, which use sizex/sizey = 0.25 of the plot area. A fixed
// pixel size made it look large in small widgets and small in large ones.
export const WATERMARK_SCALE = 0.25;
export const watermarkSize = (w: number, h: number): number =>
  Math.min(w, h) * WATERMARK_SCALE;

export const METRIC_LABELS: Record<string, string> = {
  gex: 'GEX',
  delta: 'Delta',
  charm: 'Charm',
  vanna: 'Vanna',
};
